import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SqlqueryListenerService {

  @Output() sqlQueryListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.sqlQueryListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
